import { SearchOutlined } from "@mui/icons-material";
import { Input, message } from "antd";
import Table from "atoms/Table";
import COLORS from "common/Colors";
import moment from "moment";
import React, { useRef, useState } from "react";
import { reduce } from "lodash";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { CSVLink } from "react-csv";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyleDiv = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  @media (max-width: 426px) {
    flex-direction: column;
    justify-content: start;
    align-items: start;
  }
`;

function OnboardCandidate({ data, isloading, searchTerm, setSearchTerm }) {
  const csvLinkEl = useRef();
  const { t } = useTranslation();

  // const [searchTerm, setSearchTerm] = React.useState("");
  const [onboardedEmployeeCSVlist, setOnboardedEmployeeCSVlist] = useState([]);

  const filteredDataSource = data?.filter((item) =>
    item?.firstName?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e?.target?.value);
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "firstName",
      key: "firstName",
      render: (_, record) => {
        return record?.firstName + " " + record?.lastName;
      },
    },
    {
      title: t("Employment Type"),
      dataIndex: "employmentType",
      key: "employmentType",
    },
    {
      title: t("Job Title"),
      dataIndex: "jobTitle",
      key: "jobTitle",
    },
    {
      title: t("Location"),
      dataIndex: "location",
      key: "location",
    },
    {
      title: t("Start Date"),
      dataIndex: "startDate",
      key: "startDate",
      render: (_, record) => {
        return moment(record?.startDate).format("DD-MM-YYYY");
      },
    },
  ];

  const prepareCSV = async () => {
    if (filteredDataSource.length > 0) {
      setOnboardedEmployeeCSVlist(
        reduce(
          filteredDataSource,
          function (result, list) {
            result.push({
              [t("Employee ID")]: list?.employeeId,
              [t("Location")]: list?.location,
              [t("Secondary Manager")]: list?.secondaryManager,
              [t("Company Name")]: list?.companyName,
              [t("Email ID")]: list?.emailId,
              [t("Working Hours Per Day")]: list?.workingHoursPerDay,
              [t("Phone No")]: list?.phoneNo,
              [t("First Name")]: `${list?.firstName} ${list?.lastName}`,
              [t("Candidate ID")]: list?.candidateId,
              [t("Working Days Per Week")]: list?.workingDaysPerWeek,
              [t("Pay Rate")]: list?.payRate,
              [t("Employment Type")]: list?.employmentType,
              [t("Start Date")]: moment(list?.startDate).format("DD-MM-YYYY"),
              [t("Job Title")]: list?.jobTitle,
              [t("Payment By")]: list?.paymentBy,
            });
            return result;
          },
          []
        )
      );
      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error(t("No data available to download."));
    }
  };

  const styledIcon = { color: `${COLORS.TEXT.PRIMARY}`, fontSize: "18px" };
  const styledInput = { color: `${COLORS.TEXT.PRIMARY}`, fontSize: "16px" };

  return (
    <div>
      <StyleDiv className="">
        <div>
          <Input
            style={styledInput}
            value={searchTerm}
            prefix={<SearchOutlined style={styledIcon} />}
            placeholder={t("Search People")}
            onChange={handleSearchChange}
          />
        </div>
        <div>
          <ButtonOutlined onClick={prepareCSV}>
            <span className="add-title">{t("Export CSV File")}</span>
          </ButtonOutlined>
          <CSVLink
            data={onboardedEmployeeCSVlist}
            filename={"Employee-list.csv"}
            asyncOnClick={true}
            ref={csvLinkEl}
          />
        </div>
      </StyleDiv>

      <Table
        dataSource={filteredDataSource}
        columns={columns}
        pagination={false}
        loading={isloading}
      />
    </div>
  );
}

export default OnboardCandidate;
